import React, { useCallback, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Tooltip, Table, LoadingIndicator } from '@components';
import { useSelector } from 'react-redux';
import { AlteracaoPerfilService } from '@services/alteracao-perfil';

export const HistoricoMudancaPerfil = () => {
  const users = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [historico, setHistorico] = useState([]);

  const getHistoricoMudancaPerfil = useCallback(async () => {
    setLoading(true);
    const historicoMudancaPerfil = new AlteracaoPerfilService();
    const historicoIntencaoTroca =
      await historicoMudancaPerfil.getHistoricoMudancaPerfilParticipante(
        users.matricula
      );
    setHistorico(historicoIntencaoTroca);
    setLoading(false);
  }, [users.matricula]);

  useEffect(() => {
    getHistoricoMudancaPerfil();
  }, [getHistoricoMudancaPerfil]);

  return !loading ? (
    <>
      <Helmet>
        <title>Histórico Mudança de Perfil</title>
      </Helmet>
      <div className="card">
        <div className="card-body">
          <span className="fw-bold ts-10 mb-32 mb-md-5">
            Histórico Mudança de Perfil
            <Tooltip title="Veja o Histórico Mudança de Perfil">?</Tooltip>
          </span>
          <Table
            className=" mb-4 mt-32"
            odd
            columns={[
              'Perfil',
              'Data Início Vigência',
              'Data Solicitação',
              'Data Hora Registro',
            ]}
          >
            {historico.map((linha) => {
              return (
                <tr key={linha.DataHoraRegistro}>
                  <td>{linha.Perfil}</td>
                  <td>{linha.DataInicioVigencia}</td>
                  <td>{linha.DataSolicitacao}</td>
                  <td>{linha.DataHoraRegistro}</td>
                </tr>
              );
            })}
          </Table>
        </div>
      </div>
    </>
  ) : (
    <LoadingIndicator />
  );
};
